import {toast} from 'react-toastify';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {IPresentation} from '../incase-domain/presentation';
import {handleLoadedPresentation} from '../util/presentation';
import {startUploadedPresentationAction} from '../store/actions/presentation.actions';
import {PLAYER_PRES_ID_QUERY} from '../incase-domain/online';
import {decodeExport} from '../utils/exportEncoding';

const usePresentationImport = (): ((e: FileList) => void) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return (e: FileList): void => {
        const fileReader = (): {reader: FileReader; file: File} => {
            const reader = new FileReader();
            const file = e[0];
            reader.readAsText(file);
            return {reader, file};
        };

        const uploadResult = fileReader();
        const {reader} = uploadResult;

        reader.onload = (): void => {
            try {
                let presentation = JSON.parse(decodeExport(reader.result as string)) as IPresentation;
                presentation = handleLoadedPresentation(presentation);
                dispatch(startUploadedPresentationAction(presentation));
                navigate(`/presentation?${PLAYER_PRES_ID_QUERY}=${presentation._id}`);
            } catch (error) {
                toast.error('Wrong file type!', {toastId: 'presentation-import-file'});
            }
        };

        reader.onerror = (error) => {
            toast.error(`Error: ${error.type}`, {toastId: 'presentation-import'});
        };
    };
};

export default usePresentationImport;
